import React, { useState } from 'react';
import LastUpdated from './LastUpdated';
import Popover from './Popover';
import { CopyrightContent } from '../pages/CopyrightPage';
import { AccessibilityContent } from '../pages/AccessibilityPage';
import './Footer.css';

const Footer = () => {
  const [openPopover, setOpenPopover] = useState(null);

  return (
    <>
      <footer className="footer">
        <div className="footer-content">
          <LastUpdated />
          <p>
            <button
              type="button"
              className="footer-link"
              onClick={() => setOpenPopover('accessibility')}
              title="Accessibility information"
            >
              Accessibility
            </button>
            {' | '}
            <button
              type="button"
              className="footer-link"
              onClick={() => setOpenPopover('copyright')}
              title="Copyright Information"
            >
              Copyright Information
            </button>
          </p>
        </div>
      </footer>

      {openPopover === 'accessibility' && (
        <Popover title="About Accessibility" onClose={() => setOpenPopover(null)}>
          <AccessibilityContent />
        </Popover>
      )}
      {openPopover === 'copyright' && (
        <Popover title="Copyright Policy" onClose={() => setOpenPopover(null)}>
          <CopyrightContent />
        </Popover>
      )}
    </>
  );
};

export default Footer;
